import { OrderStatus } from '../../features/order/models';

export function getOrderStatusStringName(status: OrderStatus): string {
  switch (status) {
    case OrderStatus.Created:
      return 'Creado';
    case OrderStatus.Completed:
      return 'Completado';
    case OrderStatus.InProgress:
      return 'En Producción';
    case OrderStatus.Cancelled:
      return 'Cancelado';
    case OrderStatus.OnHold:
      return 'En Espera';
    case OrderStatus.AwaitingApproval:
      return 'En Espera de Aprobación';
    case OrderStatus.Approved:
      return 'Aprobado';
    case OrderStatus.Rejected:
      return 'Rechazado';
    case OrderStatus.Archived:
      return 'Archivado';
    default:
      return 'Desconocido';
  }
}
